import axios from 'axios'
import config from './config'
import sso from './sso'
import {Message} from '@ss/mtd-vue'
import {get} from 'lodash'
import { getText } from './i18n'

let pending = [];

const cancelToken = axios.CancelToken;
const removePending = (config) => {
  for (let p in pending) {
    if (pending.hasOwnProperty(p)) {
      let item = p;
      let list = pending[p];
      if ((config.params && config.params.no_need_cancel) || (config.data && config.data.no_need_cancel)) {
        return false
      }
      if (list.url === config.url + '&' + config.method) { // 当当前请求在数组中存在时执行函数体
        list.cancel();// 执行取消操作
        pending.splice(item, 1) // 把这条记录从数组中移除
      }
    }
  }
};

const service = axios.create(config);

// POST传参序列化(添加请求拦截器)
service.interceptors.request.use(
  config => {
    removePending(config);
    config.cancelToken = new cancelToken((c) => {
      pending.push({url: config.url + '&' + config.method, cancel: c})
    });
    config.headers.common['X-Current-Page-Url'] = window.location.href;
    return config
  },
  error => {
    Message({
      type: 'warning',
      message: '报错信息'
    });
    return Promise.reject(error)
  }
);

// 返回状态判断(添加响应拦截器)
service.interceptors.response.use(
  async res => {
    removePending(res.config);

    let data = res.data;
    if (!data) {
      return res;
    }
    if (typeof data === 'string') {
      data = JSON.parse(data);
    }

    if (data && data.hasOwnProperty("status") && data.status === 401) {
      await sso.doLogin();
      return Promise.reject(res)
    }

    // 2.检查数据
    if (data && data.code !== 0) {
      if (!res.config.hideErrorMessage) {
        let message = data.message || data.data;
        Message({
          type: 'warning',
          message: `${message}`
        })
        return Promise.reject(res)
      } else {
        return data;
      }
    } else if (res.status === 401) {
      await sso.doLogin();
    }
    return data;
  },
  error => {
    if (!error.response) {
      return Promise.reject(error)
    }
    if (error.response.status === 401) {
      // 重定向到SSO登录页
      sso.doLogin();
    } else if (error.response.status === 403) {
      Message({
        type: 'warning',
        message: getText('operation_http_status_403', '用户无权限访问数据，请联系管理员进行授权')
      })
    } else if (error.response.status === 456) {
      Message({
        type: 'error',
        message: getText('operation_http_status_456', '有SQL注入风险，请修改或删除SQL语句后重新提交')
      })
    } else if (error.config.hideErrorMessage && error.response.status === 504) {
      // 超时且配置时隐藏提示信息
    } else {
      Message({
        type: 'error',
        message: `${get(error, 'response.status', getText('operation_status_unknown_error', '未知原因'))} ` + getText('operation_http_status_error', '请求出错了哦~')
      })
    }
    return Promise.reject(error)
  }
);

export default service
